export const filter = {
    id: "",
    name: "",
    branch_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};